import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { Chatbot } from "./Chatbot";
import { Toaster } from "sonner";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-white">
    <Nav />
    <main className="flex-1 pt-20">{children}</main>
    <Footer />
    <Chatbot />
    <Toaster position="top-center" richColors />
  </div>
);
